import React, { PropsWithChildren, useMemo } from 'react'

function createComponentContext<ContextValue extends object | null>(
  rootComponentName: string,
  defaultContextValue?: ContextValue
) {
  const Context = React.createContext<ContextValue | undefined>(defaultContextValue)

  function Provider(props: PropsWithChildren<ContextValue>) {
    const { children, ...context } = props

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const contextValue = useMemo(() => context, Object.values(context)) as ContextValue

    return <Context.Provider value={contextValue}>{children}</Context.Provider>
  }

  Provider.dispalyName = rootComponentName + 'Provider'

  function useContext(consumerName: string) {
    const context = React.useContext(Context)

    if (context) return context

    if (defaultContextValue !== undefined) return defaultContextValue

    throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``)
  }

  return [Provider, useContext] as const
}

export { createComponentContext }
